import * as CoreActions from "@common/store/actions/core.actions";

import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, map, mergeMap, switchMap, withLatestFrom} from "rxjs/operators";
import {inject, Injectable} from "@angular/core";
import {CoreService} from '@common/services/core.service';
import * as UserActions from '@common/store/actions/user.actions';
import {OrganizationSettings, CabinetType} from '@common/models/cabinet.models';
import {of} from 'rxjs';

@Injectable()
export class CoreEffects {

    private actions$ = inject(Actions);
    private coreService = inject(CoreService);

    loadCountries$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CoreActions.LoadCountriesPhoneMasks),
            switchMap(() => {
                return this.coreService._getCountries().pipe(
                    map(res => CoreActions.LoadCountriesPhoneMasksSuccess({countriesPhoneMasks: res}))
                );
            })
        );
    });

    loadCurrentAssociation$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CoreActions.LoadCurrentOrganization),
            withLatestFrom(this.coreService.selectCurrentCabinetType$()),
            switchMap(([action, currentCabinetType]) => {
                return this.coreService._getOrganization(action.id).pipe(
                    map(res => {
                        const preparedAssociation: OrganizationSettings = {...res, cabinetTypeRoute: res.cabinetType?.toLowerCase()?.replace('_', '-') as CabinetType};
                        if (preparedAssociation?.cabinetTypeRoute !== currentCabinetType) {
                            return UserActions.LogOut();
                        }

                        if (currentCabinetType === 'housing-organization') {
                            this.coreService.updateAssociationParts(res.id);
                        }

                        return CoreActions.LoadCurrentOrganizationSuccess({organizationSettings: {...preparedAssociation, id: action.id}});
                    }),
                    catchError(() => {
                        this.coreService.navigateToGreeting();
                        return of();
                    })
                );
            })
        );
    });

    loadAssociationPartsSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CoreActions.LoadAssociationParts),
            mergeMap((action) => {
                return this.coreService._getAssociationParts(action.id).pipe(
                    map(res => CoreActions.LoadAssociationPartsSuccess({payload: res}))
                );
            })
        )
    );

    loadLoadTenantCurrentOrganization$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CoreActions.LoadTenantCurrentOrganization),
            switchMap((action) => {
                return this.coreService._getTenantOrganization(action.id).pipe(
                    map(res => {
                        let apartments = res.apartments ? res.apartments : [];
                        if (res.buildings?.length) {
                            for (let i = 0; i < res.buildings.length; i++) {
                                if (res.buildings[i].apartments) {
                                    apartments = [...apartments, ...res.buildings[i].apartments];
                                }
                            }
                        }

                        return CoreActions.LoadTenantCurrentOrganizationSuccess({association: {...res, id: action.id, apartments}});
                    })
                );
            })
        );
    });
}
